import { atom } from 'recoil';

/**
 * Atom to manage App Integration session state.
 * 
 * Structure when active:
 * {
 *   sessionId: string,
 *   ticketId: string | null,          // may be set async after ticket creation
 *   chatThreadId: string | null,
 *   corpId: string,
 *   projectId: string,
 *   userId: string,
 *   startTime: number,                // epoch ms
 *   status: 'active' | 'ending',
 *   endReason: string | null,         // 'manual_stop' | 'silence_auto_end' | 'force_cleanup'
 * }
 * 
 * null when no session is active.
 */
export const appIntegrationSessionAtom = atom({
    key: 'appIntegrationSessionAtom',
    default: null,
});

/**
 * Silence state for App Integration popup.
 * 
 * Structure:
 * {
 *   isSilent: boolean,                // both customer and agent are silent
 *   silenceStartedAt: number | null,  // epoch ms when silence started
 *   type: string | null,              // optional event type, e.g. 'silenceTimeout'
 * }
 */
export const appIntegrationSilenceAtom = atom({
    key: 'appIntegrationSilenceAtom',
    default: {
        isSilent: false,
        silenceStartedAt: null,
        type: null,
    },
});
